import { Base } from "../../framework/base";
import { ISalaryPeriodTypeItem, SalaryPeriodTypeItem } from "./salaryPeriodTypeItem";

export interface ISalaryPeriodTypeItems {
    items: ISalaryPeriodTypeItem[];
    hasMore: boolean;
    page: number;
}

export class SalaryPeriodTypeItems implements ISalaryPeriodTypeItems {
    items: SalaryPeriodTypeItem[];
    hasMore: boolean;
    page: number;

    constructor();
    constructor(obj: ISalaryPeriodTypeItems);
    constructor(obj?: any) {
        this.hasMore = obj && obj.hasMore || false;
        this.page = obj && obj.page || 1;
        this.items = Base.getTypedArray<SalaryPeriodTypeItem>(obj ? obj.items : null, SalaryPeriodTypeItem);
    }
}
